<template>
  <!-- 完成订单 -->
  <div>
    <van-overlay :show="showLoading">
      <div class="wrapper" @click.stop>
        <van-loading size="24px" vertical>上传中...</van-loading>
      </div>
    </van-overlay>

    <van-sticky>
      <van-nav-bar title="完成订单" left-text="返回" left-arrow @click-left="goback" />
    </van-sticky>
    <!-- 表单 -->
    <van-form style="text-align: left" ref="completeRules">
      <!--      <van-cell title="安装地区" value="江苏-苏州" />-->
      <van-field
        label="下单充电桩类型"
        :value="orderDetail.storeName"
        input-align="right"
        readonly
        label-width="8rem"
      />
      <van-field
        label="品牌"
        :value="orderDetail.deviceBrandName"
        input-align="right"
        readonly
        label-width="8rem"
      />
      <van-field
        label="车型"
        :value="orderDetail.modelName"
        input-align="right"
        readonly
        label-width="8rem"
      />
      <van-field
        label="所属区域"
        :value="orderDetail.regionName"
        input-align="right"
        readonly
        label-width="8rem"
      />
      <van-field
        label="所属公司"
        :value="orderDetail.companyName"
        input-align="right"
        readonly
        label-width="8rem"
      />
      <van-field
        label="订单类型"
        :value="orderTypeFormat(orderDetail)"
        input-align="right"
        readonly
        label-width="8rem"
      />
      <van-field
        label="维修类型"
        :value="repairTypeFormat(orderDetail)"
        v-show="orderDetail.orderType === 2"
        input-align="right"
        readonly
        label-width="8rem"
        :isLink="canEdit"
        @click="canEdit ? (showRepairType = true) : ''"
        :required="orderDetail.orderType === 2"
        :rules="[
          {
            required: required && orderDetail.orderType === 2,
            message: '请选择维修类型'
          },
        ]"
      />
      <van-field
        label="原订单号"
        :value="orderDetail.oldOrderNum"
        input-align="right"
        readonly
        v-show="orderDetail.orderType === 2"
      />
      <van-field
        label="预约单号"
        :value="orderDetail.pileModel"
        input-align="right"
        readonly
        label-width="8rem"
      />
      <van-field
        label="客户姓名"
        :value="orderDetail.customerName"
        input-align="right"
        readonly
        label-width="8rem"
      />
      <van-field
        label="手机号码"
        :value="orderDetail.phone"
        input-align="right"
        readonly
        label-width="8rem"
      />
      <van-field
        v-model="orderDetail.detailAddress"
        label="详细地址"
        input-align="right"
        placeholder="请填写详细地址"
        clearable
        type="textarea"
        rows="1"
        required
        autosizeinput-align="right"
        label-width="8rem"
        :rules="[{ required: true }]"
      />
      <van-field
        label="车架号"
        :value="orderDetail.frameNo"
        input-align="right"
        readonly
      />
      <van-field
        label="故障描述"
        :value="orderDetail.faultDescription"
        input-align="right"
        readonly
        v-show="orderDetail.orderType === 2"
      />
      <van-field
        label="订单备注"
        :value="orderDetail.orderRemark"
        input-align="right"
        readonly
      />
      <van-field label="跟进备注" label-width="5rem" input-align="left" rows="5" readonly>
        <template #button>
          <div style="height: 5rem; overflow: auto">
            <div
              v-for="(item, index) in followList"
              style="width: 200px; text-align: left; margin: 0"
              :key="index"
            >
              {{ formattedFollowInfo(item) }}
            </div>
          </div>
        </template>
      </van-field>

      <van-field
        label="原充电桩编号"
        :value="oldDeviceNum"
        input-align="right"
        readonly
        v-show="orderDetail.orderType === 2"
      />
      <van-field
        v-model="orderDetail.deviceNum"
        v-show="checkShowDeviceNum(orderDetail)"
        required
        clearable
        label="充电桩编号"
        input-align="right"
        label-width="5rem"
        placeholder="请录入充电桩编号"
        :rules="[
          {
            required: checkShowDeviceNum(orderDetail),
          },
        ]"
        readonly
        @click="onDeviceNumClick"
      />
      <van-button
        v-if="orderDetail.deviceNum"
        type="warning"
        size="small"
        style="margin: 0.5rem 1rem"
        @click="unbindDevice"
      >
        解绑充电桩
      </van-button>
      <van-field
        label="前端线材"
        v-show="true"
        :value="valueByKey(orderDetail.frontEndCable, frontEndCableOptions)"
        :required="orderDetail.orderType === 1"
        :rules="[
          {
            required: orderDetail.orderType === 1,
			message: '请选择前端线材'
          },
        ]"
        input-align="right"
        readonly
        label-width="8rem"
        :isLink="canEdit"
        @click="canEdit?showFontEndCableOptions = true:''"
      />
      <!-- <template #button>
          <van-button native-type="button" @click='scanCode()' type="primary" size="small">扫描录入</van-button>
          <van-button native-type="button" @click='deviceListIsShow = true' type="primary"  size="small">现有充电桩桩</van-button>
          <van-button native-type="button" @click='showDeviceCategory = true' type="primary"  size="small">现有充电桩</van-button>
        </template> -->

      <van-field
        input-align="right"
        v-show="orderDetail.deviceNum !== ''"
        readonly
        v-model="orderDetail.categoryName"
        required
        label="充电桩类型"
        placeholder="请选择充电桩类型"
        @click="categoryListIsShow = false"
        :rules="[{ required: required }]"
      />
      <van-field
        input-align="right"
        v-show="true"
        readonly
        clickable
        :value="selfPickupStr"
        label="是否自提桩"
        placeholder="点击选择是否用户自提桩"
        @click="showSelfPickup = true"
      />
      <van-field
        input-align="right"
        v-show="checkShowUnSelfPickup(orderDetail)"
        readonly
        v-model="orderDetail.powerSource"
        required
        label="电源来源"
        placeholder="请选择电池来源"
        @click="showSource = true"
        :rules="[{ required: required && checkRequiredUnSelfPickup(orderDetail) }]"
      />
      <van-field
        input-align="right"
        v-show="checkShowUnSelfPickup(orderDetail)"
        readonly
        v-model="orderDetail.cableBrandNameTmp"
        required
        label="电缆品牌"
        placeholder="请选择电缆品牌"
        @click="showCableBrand = true"
        :rules="[{ required: required && checkRequiredUnSelfPickup(orderDetail) }]"
      />
      <van-field
        input-align="right"
        v-show="checkShowUnSelfPickup(orderDetail) && showCableBrandOther"
        v-model="orderDetail.cableBrandName"
        required
        label="其他电缆品牌"
        placeholder="请填写电缆品牌"
        :rules="[{ required: required && checkRequiredUnSelfPickup(orderDetail) }]"
      />
      <van-field
        input-align="right"
        v-show="checkShowUnSelfPickup(orderDetail)"
        v-model="orderDetail.lineLength"
        required
        label="总共使用电缆"
        placeholder="请填写用线长度"
        type="number"
        :rules="[{ required: required && checkRequiredUnSelfPickup(orderDetail) }]"
      />
      <van-field
        input-align="right"
        v-show="checkShowUnSelfPickup(orderDetail)"
        v-model="orderDetail.addOutlay"
        required
        label="总增项费用"
        placeholder="请填写增项费用"
        type="number"
        :rules="[{ required: required && checkRequiredUnSelfPickup(orderDetail) }]"
      />
      <van-field
        input-align="right"
        v-show="checkShowUnSelfPickup(orderDetail)"
        readonly
        clickable
        required
        :value="signExemptionStr"
        label="是否签免责"
        placeholder="点击选择用户是否签免责"
        @click="showChoice1 = true"
        :rules="[{ required: required && checkRequiredUnSelfPickup(orderDetail) }]"
      />
      <van-field
        input-align="right"
        v-show="false"
        readonly
        clickable
        required
        :value="isSelfPickup"
        label="是否自提桩"
        placeholder="点击选择是否用户自提桩"
        @click="showChoiceX = true"
        :rules="[{ required: required }]"
      />

      <van-field
        input-align="right"
        v-show="checkShowUnSelfPickup(orderDetail)"
        readonly
        clickable
        :value="isWiring"
        label="是否自布线"
        placeholder="点击选择是否自布线"
        @click="showChoiceY = true"
      />
      <van-field
        input-align="right"
        v-show="checkShowUnSelfPickup(orderDetail)"
        readonly
        clickable
        :value="houseType"
        label="住宅类型"
        placeholder="点击选择住宅类型"
        @click="showChoiceZ = true"
      />

      <van-field
        input-align="right"
        v-show="orderDetail.signExemption === 1 && checkShowUnSelfPickup(orderDetail)"
        required
        name="reserve3Uploader"
        label="免责图"
      >
        <template #input>
          <van-uploader
            :multiple="true"
            :max-count="40"
            v-model="orderImage.reserve3Uploader"
            :before-read="imageUploadOuther"
            @click-upload="flagUpload = true"
            :name="-2"
            :before-delete="deleteImage"
            :preview-full-image="false"
            @click-preview="(item, index) => { previewOtherImages(orderImage.reserve3Uploader, index); return false; }"
          />
        </template>
      </van-field>
      <!-- <van-field
        input-align="right"
        v-show="checkShowUnSelfPickup(orderDetail)"
        label-width="10rem"
        readonly
        clickable
        required
        :value="purchaseExtensionStr"
        label="是否购买延长线"
        placeholder="点击选择用户是否购买延长线"
        @click="showChoice2 = true"
        :rules="[{ required: required && checkRequiredUnSelfPickup(orderDetail) }]"
      /> -->
      <van-field
        label="超出后物料"
        label-width="5rem"
        v-show="orderDetail.isSelfPickup !== 1"
      >
        <template #button>
          <van-button
            native-type="button"
            type="primary"
            size="small"
            @click="showMaterial = true"
            >添加物料</van-button
          >
        </template>
      </van-field>
      <van-row>
        <van-col span="4" align="center" class="row-text">类型</van-col>
        <van-col span="6" align="center" class="row-text">型号</van-col>
        <van-col span="4" align="center" class="row-text">单价</van-col>
        <van-col span="4" align="center" class="row-text">数量</van-col>
        <van-col span="4" align="center" class="row-text">实收</van-col>
        <van-col span="2" align="center" class="row-text">操作</van-col>
      </van-row>
      <van-row
        align="center"
        v-for="(item, index) in orderDetail.materialOrderList"
        :key="index"
        v-show="orderDetail.isSelfPickup !== 1"
      >
        <van-col span="4" align="center"><van-field :label="item.typeName" /></van-col>
        <van-col span="6" align="center"><van-field :label="item.modelName" /></van-col>
        <van-col span="4" align="center"
          ><van-field
            type="number"
            input-align="center"
            v-model="item.meterialPrice"
            @change="calcMaterialTotal(item)"
          ></van-field
        ></van-col>
        <van-col span="4" align="center"
          ><van-field
            type="number"
            input-align="center"
            placeholder="数量"
            v-model="item.num"
            @change="calcMaterialTotal(item)"
        /></van-col>
        <van-col span="4" align="center"
          ><van-field
            type="number"
            input-align="center"
            placeholder="实收金额"
            v-model="item.actualAmount"
        /></van-col>
        <van-col span="2" align="center"
          ><van-cell style="color: red" title="×" @click="deleteMaterial(index)"
        /></van-col>
      </van-row>
      <van-field
        input-align="right"
        :value="changeTime(orderDetail.installTime)"
        clickable
        :label="installTimeLable"
        placeholder="请选择时间"
        required
        readonly
        @click="
          showTime = true;
          currentDate = new Date();
        "
        :rules="[{ required: required }]"
      />
      <van-field
        input-align="right"
        label-width="10rem"
        v-show="orderDetail.orderType === 2 && orderDetail.repairType === 1"
        readonly
        v-model="oldDisposeTypeStr"
        required
        label="旧充电桩处理方式"
        placeholder="请选择旧充电桩处理方式"
        @click="showDisposeType = true"
        :rules="[
          {
            required:
              required && orderDetail.orderType === 2 && orderDetail.repairType === 1,
          },
        ]"
      />
      <van-field
        input-align="right"
        v-model="orderCourier.courierNum"
        label="快递单号"
        placeholder="请填写快递单号"
        clearable
        type="input"
        required
        autosizeinput-align="right"
        label-width="8rem"
        v-show="orderDetail.oldDisposeType === 2"
        :rules="[{ required: required && orderDetail.oldDisposeType === 2 }]"
      />
      <van-field
        input-align="right"
        required
        name="courierUploader"
        label="快递单据图"
        v-show="orderDetail.oldDisposeType === 2"
        :rules="[
          {
            required: required && orderDetail.oldDisposeType === 2,
            message: '请上传快递单据图',
          },
        ]"
      >
        <template #input>
          <van-uploader
            v-model="orderCourier.courierImageUploader"
            :before-read="imageUpload"
            @click-upload="flagUpload = true"
            :name="-4"
            :before-delete="deleteImage"
          />
        </template>
      </van-field>

      <div v-for="img in imageSetting.templateDetailList" v-bind:key="img.id">
        <van-field
          input-align="right"
          :required="img.isRequired === 1"
          :name="'tmpUploader' + img.id"
          :label="img.imageName"
          :rules="[
            {
              required: img.isRequired === 1 && required,
              message: '请上传' + img.imageName,
            },
          ]"
        >
          <template #input>
            <div 
              :class="{'has-multiple-images': (img.imageUploader && img.imageUploader.length > 1) || getImageCount(img.url) > 1}"
              style="position: relative; display: inline-block;"
            >
              <!-- 上传按钮 -->
            <van-uploader
                :multiple="true"
                :max-count="img.maxCount || 10"
              v-model="img.imageUploader"
                :before-read="imageUploadOuther"
              @click-upload="flagUpload = true"
              :name="img.id"
              :before-delete="deleteImage"
                :show-upload="img.imageUploader ? img.imageUploader.length < (img.maxCount || 10) : true"
                :preview-full-image="false"
                @click-preview="(item, index) => { previewImages(img, index); return false; }"
                :ref="'uploader_' + img.id"
              />
              <!-- 图片数量标签，显示在第一张预览图片上 -->
              <div
                v-if="(img.imageUploader && img.imageUploader.length > 1) || getImageCount(img.url) > 1"
                class="image-count-badge"
                :style="getBadgeStyle(img.id)"
              >
                {{ (img.imageUploader && img.imageUploader.length) || getImageCount(img.url) }}张
              </div>
            </div>
          </template>
        </van-field>
      </div>

      <van-field
        input-align="right"
        required
        name="surveyUploader"
        label="勘测确认单"
        :rules="[{ required: required, message: '请上传勘测确认单' }]"
      >
        <template #input>
          <van-uploader
            :multiple="true"
            :max-count="40"
            v-model="orderImage.surveyImageUploader"
            :before-read="imageUploadOuther"
            :name="-3"
            :before-delete="deleteImage"
            :preview-full-image="false"
            @click-preview="(item, index) => { previewOtherImages(orderImage.surveyImageUploader, index); return false; }"
          />
        </template>
      </van-field>

      <van-field input-align="right" name="otherUploader" label="其他多图">
        <template #input>
          <van-uploader
            :multiple="true"
            :max-count="40"
            v-model="orderImage.reserve1Uploader"
            :before-read="imageUploadOuther"
            :name="-1"
            :before-delete="deleteImage"
            :preview-full-image="false"
            @click-preview="(item, index) => { previewOtherImages(orderImage.reserve1Uploader, index); return false; }"
          />
        </template>
      </van-field>

      <van-field input-align="right" name="videoUploader" label="相关视频">
        <template #input>
          <van-uploader
            accept="video/*"
            v-model="orderImage.videoUploader"
            :name="-99"
            :after-read="afterRead"
            :before-delete="deleteImage"
          >
            <template slot="preview-cover">
              <video
                width="100%"
                type="video/mp4"
                :src="transformUrl(orderDetail.videoUrl)"
                muted="muted"
                preload="preload"
                controls="controls"
              ></video>
            </template>
          </van-uploader>
        </template>
      </van-field>
      <van-cell
        style="color: red"
        v-show="orderDetail.status === 4"
        title="驳回理由"
        :value="orderDetail.rejectRemark"
      />
      <div style="margin: 1rem" v-if="canEdit">
        <van-button
          round
          block
          type="warning"
          size="small"
          native-type="submit"
          @click="onSubmit(0)"
          >暂存订单</van-button
        >
      </div>
      <div style="margin: 1rem" v-if="canEdit">
        <van-button
          round
          block
          type="info"
          size="small"
          native-type="submit"
          @click="onSubmit(1)"
          >完成订单</van-button
        >
      </div>
      <div
        style="margin: 1rem"
        v-if="
          orderDetail.status === 3 &&
          authorization('/home-admin/order/order-manage/examine')
        "
      >
        <van-button
          round
          block
          type="info"
          size="small"
          native-type="button"
          @click="toExamine(orderDetail.id)"
          >审核订单</van-button
        >
      </div>
    </van-form>
    <!-- 弹出层 -->
    <van-popup v-model="showSource" position="bottom">
      <van-picker
        title="电源来源"
        show-toolbar
        :columns="powerSourceCol"
        @confirm="onSource"
        @cancel="showSource = false"
      />
    </van-popup>
    <van-popup v-model="showCableBrand" position="bottom">
      <van-picker
        title="电缆品牌"
        value-key="brandName"
        show-toolbar
        :columns="cableBrandCol"
        @confirm="onCableBrand"
        @cancel="showCableBrand = false"
      />
    </van-popup>
    <van-popup v-model="showChoice1" position="bottom">
      <van-picker
        value-key="label"
        show-toolbar
        :columns="choiceList1"
        @confirm="onChoice1"
        @cancel="showChoice1 = false"
      />
    </van-popup>
    <van-popup v-model="showChoice1" position="bottom">
      <van-picker
        value-key="label"
        show-toolbar
        :columns="choiceList1"
        @confirm="onChoice1"
        @cancel="showChoice1 = false"
      />
    </van-popup>

    <van-popup v-model="showChoiceX" position="bottom">
      <van-picker
        value-key="label"
        show-toolbar
        :columns="choiceListX"
        @confirm="onChoiceX"
        @cancel="showChoiceX = false"
      />
    </van-popup>

    <van-popup v-model="showChoiceY" position="bottom">
      <van-picker
        value-key="label"
        show-toolbar
        :columns="choiceListY"
        @confirm="onChoiceY"
        @cancel="showChoiceY = false"
      />
    </van-popup>

    <van-popup v-model="showChoiceZ" position="bottom">
      <van-picker
        value-key="houseTypeName"
        show-toolbar
        :columns="houseTypeList"
        @confirm="onChoiceZ"
        @cancel="showChoiceZ = false"
      />
    </van-popup>

    <van-popup v-model="deviceListIsShow" position="bottom">
      <van-picker
        value-key="label"
        show-toolbar
        :columns="deviceList"
        @confirm="onDeviceList"
        @cancel="deviceListIsShow = false"
      />
    </van-popup>
    <van-popup v-model="categoryListIsShow" position="bottom">
      <van-picker
        value-key="categoryName"
        show-toolbar
        :columns="deviceCategoryCol"
        @confirm="onCategoryList"
        @cancel="categoryListIsShow = false"
      />
    </van-popup>
    <van-popup v-model="showChoice2" position="bottom">
      <van-picker
        value-key="label"
        show-toolbar
        :columns="choiceList2"
        @confirm="onChoice2"
        @cancel="showChoice2 = false"
      />
    </van-popup>
    <van-popup v-model="showSelfPickup" position="bottom">
      <van-picker
        value-key="label"
        show-toolbar
        :columns="commonBoolChoiceList"
        @confirm="onSelfPickUp"
        @cancel="showSelfPickup = false"
      />
    </van-popup>
    <!--    <van-popup v-model="showArea" position="bottom">
      <van-area :area-list="areaList" @confirm="onConfirm" @cancel="showArea = false"/>
    </van-popup>-->
    <van-popup v-model="showRepairType" position="bottom">
      <!-- 维修类型(1 更换充电桩,2 更换漏保,3 地线维修,4 其他维修) -->
      <van-picker
        title="维修类型"
        show-toolbar
        value-key="label"
        :columns="repairTypeOptions"
        @confirm="onRepairTypeConfirm"
        @cancel="showRepairType = false"
      />
    </van-popup>

	<van-popup v-model="showFontEndCableOptions" position="bottom">
      <van-picker
        title="前端线材"
        show-toolbar
        value-key="label"
        :columns="frontEndCableOptions"
        @confirm="
          (row) => {
            orderDetail.frontEndCable = row.value;
            showFontEndCableOptions = false;
          }
        "
        @cancel="showFontEndCableOptions = false"
      />
    </van-popup>

    <van-popup v-model="showTime" position="bottom">
      <van-datetime-picker
        type="datetime"
        title="请选择时间"
        v-model="currentDate"
        @confirm="onTime"
        @cancel="showTime = false"
      />
    </van-popup>
    <van-popup v-model="showMaterial" position="bottom">
      <van-cascader
        v-model="materialModelValue"
        title="请选择消耗的物料"
        :options="materialList"
        @close="showMaterial = false"
        @finish="onFinish"
      />
    </van-popup>
    <van-popup v-model="showDeviceCategory" position="bottom">
      <van-cascader
        v-model="deviceCategoryValue"
        title="请选择充电桩"
        :options="deviceCategoryList"
        @close="showDeviceCategory = false"
        @finish="onDeviceCategory"
      />
    </van-popup>
    <van-popup v-model="showDisposeType" position="bottom">
      <van-picker
        title="旧充电桩处理方式"
        show-toolbar
        value-key="label"
        :columns="disposeTypeList"
        @confirm="onDisposeType"
        @cancel="showDisposeType = false"
      />
    </van-popup>
    <van-popup v-model="showExamine" position="bottom">
      <van-field
        v-model="examineParams.rejectRemark"
        rows="6"
        autosize
        label="驳回理由"
        type="textarea"
        maxlength="80"
        placeholder="驳回需要填写驳回理由"
        show-word-limit
      />
      <van-button
        type="danger"
        style="margin: 1rem; float: right"
        @click="confirmExamine(4)"
        >驳回</van-button
      >
      <van-button
        type="primary"
        style="margin: 1rem; float: right"
        @click="confirmExamine(6)"
        >通过</van-button
      >
    </van-popup>
    <van-popup v-model="showChangeDevice" position="bottom">
      <van-field
        style="position: absolute; top: 35px; margin: auto; z-index: 99"
        placeholder="搜索"
        v-model="searchDevice"
        input-align="center"
        @input="onInput"
      ></van-field>
      <van-picker
        show-toolbar
        :columns="changeDeviceList"
        value-key="deviceNumAndCategoryName"
        @confirm="classChangeDevice"
        @cancel="showChangeDevice = false"
      />
    </van-popup>
    
    <!-- 自定义图片预览弹窗，带底部缩略图 -->
    <van-popup 
      v-model="showImagePreview" 
      position="center"
      :style="{ width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.9)' }"
      :close-on-click-overlay="true"
    >
      <div style="height: 100%; display: flex; flex-direction: column;">
        <!-- 关闭按钮 -->
        <div style="position: absolute; top: 10px; right: 10px; z-index: 1000;">
          <van-icon 
            name="cross" 
            size="24px" 
            color="#fff" 
            @click="showImagePreview = false"
            style="cursor: pointer;"
          />
        </div>
        
        <!-- 主预览区域 -->
        <div 
          ref="mobileImagePreviewContainer"
          style="flex: 1; display: flex; align-items: center; justify-content: center; position: relative; overflow: hidden; touch-action: none;"
          @touchstart="handleTouchStart"
          @touchmove="handleTouchMove"
          @touchend="handleTouchEnd"
          @dblclick="handleDoubleClickMobile"
        >
          <img 
            ref="mobilePreviewImage"
            :src="previewImageList[currentPreviewIndex]" 
            alt=""
            :style="{
              maxWidth: '100%',
              maxHeight: '100%',
              objectFit: 'contain',
              transform: `scale(${mobileImageScale}) translate(${mobileImageTranslateX}px, ${mobileImageTranslateY}px)`,
              transition: isMobileDragging ? 'none' : 'transform 0.3s',
              touchAction: 'none'
            }"
            @load="onMobileImageLoad"
          />
          <!-- 图片计数器 -->
          <div 
            v-if="previewImageList.length > 1"
            style="
              position: absolute;
              top: 20px;
              left: 50%;
              transform: translateX(-50%);
              background-color: rgba(0, 0, 0, 0.6);
              color: white;
              padding: 4px 12px;
              border-radius: 4px;
              font-size: 14px;
            "
          >
            {{ currentPreviewIndex + 1 }} / {{ previewImageList.length }}
          </div>
          <!-- 上一张按钮 -->
          <div 
            v-if="previewImageList.length > 1"
            @click="prevImageMobile"
            style="
              position: absolute;
              left: 10px;
              background-color: rgba(0, 0, 0, 0.5);
              color: white;
              width: 40px;
              height: 40px;
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 24px;
            "
          >
            ‹
          </div>
          <!-- 下一张按钮 -->
          <div 
            v-if="previewImageList.length > 1"
            @click="nextImageMobile"
            style="
              position: absolute;
              right: 10px;
              background-color: rgba(0, 0, 0, 0.5);
              color: white;
              width: 40px;
              height: 40px;
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 24px;
            "
          >
            ›
          </div>
          <!-- 缩放控制按钮 -->
          <div 
            style="position: absolute; bottom: 120px; right: 10px; z-index: 10; display: flex; flex-direction: column; gap: 10px;"
            @click.stop
          >
            <div 
              @click="zoomInMobile"
              style="
                background-color: rgba(0, 0, 0, 0.5);
                color: white;
                width: 40px;
                height: 40px;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 20px;
              "
            >
              +
            </div>
            <div 
              @click="zoomOutMobile"
              style="
                background-color: rgba(0, 0, 0, 0.5);
                color: white;
                width: 40px;
                height: 40px;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 20px;
              "
            >
              −
            </div>
            <div 
              @click="resetMobileImageZoom"
              style="
                background-color: rgba(0, 0, 0, 0.5);
                color: white;
                width: 40px;
                height: 40px;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 14px;
              "
            >
              ↺
            </div>
          </div>
        </div>
        
        <!-- 底部缩略图列表 -->
        <div 
          v-if="previewImageList.length > 1"
          style="
            height: 100px;
            background-color: rgba(0, 0, 0, 0.8);
            display: flex;
            align-items: center;
            overflow-x: auto;
            padding: 10px;
            border-top: 1px solid rgba(255, 255, 255, 0.2);
          "
        >
          <div
            v-for="(item, index) in previewImageList"
            :key="index"
            @click="switchImageMobile(index)"
            style="
              margin: 0 5px;
              flex-shrink: 0;
              border: 2px solid;
              border-radius: 4px;
              overflow: hidden;
              transition: all 0.3s;
            "
            :style="{
              opacity: currentPreviewIndex === index ? 1 : 0.6,
              borderColor: currentPreviewIndex === index ? '#1989fa' : 'transparent'
            }"
          >
            <img 
              :src="item" 
              alt=""
              style="width: 70px; height: 70px; object-fit: cover; display: block;"
            />
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { areaList } from "@vant/area-data";
import moment from "moment";
import { Toast, Dialog } from "vant";
import ImageCompressor from "compressorjs";
import { authorization } from "../authorization/authorization";
import { orderTypeFormat, repairTypeFormat ,valueByKey} from "../components/common/format";
export default {
  data() {
    return {
showFontEndCableOptions:false,
showRepairType: false,
showLoading: false,
      showImagePreview: false,
      previewImageList: [],
      currentPreviewIndex: 0,
      mobileImageScale: 1,
      mobileImageTranslateX: 0,
      mobileImageTranslateY: 0,
      isMobileDragging: false,
      touchStartDistance: 0,
      touchStartScale: 1,
      lastTouchCenter: { x: 0, y: 0 },
      badgePositions: {}, // 存储每个上传器的数量标签位置
      showChangeDevice: false,
      searchDevice: "",
      goBackUrl: this.$route.query.goBackUrl,
      goBackType: this.$route.query.type,
      showExamine: false,
      examineParams: {
        orderIds: [],
        orderId: "",
        rejectRemark: "",
        type: "",
      },
      showDeviceCategory: false,
      categoryListIsShow: false,
      powerSourceCol: ["独立电表", "物业取电", "自家电表", "其他"],
      cableBrandCol: [],
      currentDate: new Date(),
      deviceListIsShow: false,
      flagUpload: true,
      signExemptionStr: "",
      isDockingRequired: "",
      isSelfPickup: "",
      isWiring: "",
      houseType: "",
      purchaseExtensionStr: "",
      selfPickupStr: "",
      oldDisposeTypeStr: "",
      required: true,
      orderId: sessionStorage.getItem("orderId"),
      deviceNum: this.$route.query.deviceNum,
      installTimeLable: "实际安装时间",
      orderDetail: {},
      changeDeviceList: [],
      oldChangeDeviceList: [],
      followList: [],
      androidAttrs: null,
      oldDeviceNum: "",
      orderCourier: {
        orderId: "",
        courierNum: "",
        courierImageUrl: "",
        courierImageUploader: [],
      },
      //存储图片预览路径
      orderImage: {
        mainImageUploader: [],
        sideImageUploader: [],
        junctionBoxImageUploader: [],
        groupPhotoImageUploader: [],
        drivingLicenseImageUploader: [],
        surveyImageUploader: [],
        installConfirmImageUploader: [],
        toolBlanketImageUploader: [],
        reserve1Uploader: [],
        reserve3Uploader: [],
        videoUploader: [],
      },
      uploader: [{ url: "https://img01.yzcdn.cn/vant/leaf.jpg" }],
      imageSetting: {},
      orderImageDatas: [],
      showArea: false,
      showTime: false,
      showSource: false,
      showCableBrand: false,
      showCableBrandOther: false,
      showChoice1: false,
      showChoice2: false,
      showMaterial: false,
      showChoiceX: false,
      showChoiceY: false,
      showChoiceZ: false,
      showSelfPickup: false,
      showDisposeType: false,
      areaList,
      houseTypeList: [
        {
          id: 0,
          houseTypeName: "农村自建房",
        },
        {
          id: 1,
          houseTypeName: "城市小区",
        },
        {
          id: 2,
          houseTypeName: "城市自建房",
        },
        {
          id: 3,
          houseTypeName: "工厂",
        },
        {
          id: 4,
          houseTypeName: "其他",
        },
      ],

      choiceListX: [
        {
          value: 0,
          label: "否",
        },
        {
          value: 1,
          label: "是",
        },
      ],
      choiceListY: [
        {
          value: 0,
          label: "否",
        },
        {
          value: 1,
          label: "是",
        },
      ],
      choiceList1: [
        {
          value: 0,
          label: "未签",
        },
        {
          value: 1,
          label: "已签",
        },
      ],
      choiceList2: [
        {
          value: 0,
          label: "未购买",
        },
        {
          value: 1,
          label: "已购买",
        },
      ],
      repairTypeOptions: [
        { value: 1, label: "更换充电桩" },
        { value: 2, label: "更换漏保" },
        { value: 3, label: "地线维修" },
        { value: 4, label: "其他维修" },
      ],
frontEndCableOptions: [
		{ value: 1, label: "铜" },
        { value: 2, label: "铝" },
        { value: 9, label: "其他" },
],
      commonBoolChoiceList: [
        {
          value: 1,
          label: "是",
        },
        {
          value: 0,
          label: "否",
        },
      ],
      disposeTypeList: [
        {
          value: 1,
          label: "保留",
        },
        {
          value: 2,
          label: "邮寄",
        },
      ],
      installationTime: "",
      materialList: [],
      materialModelValue: "",
      deviceCategoryValue: "",
      deviceList: [],
      deviceCategoryCol: [],
      deviceCategoryList: [],
      deviceNumBeforeReplace: "",
    };
  },
  computed: {
    canEdit() {
      return this.orderDetail.status === 2 || this.orderDetail.status === 4;
    },
  },
  created() {
    //字典
    this.selMaterialType();
    this.getDeviceList();
    this.queryCategoryDrown();
    this.queryCableBrandDrown();
    this.selDeviceCategory();
    //订单数据
    this.selectOrderDetail(true);
    //跟进数据
    this.selectFollowDetail();
    // 在页面一进来时就去判断当前使用机型
    const model = navigator.userAgent;
    this.androidAttrs = model.indexOf("Android") > -1 || model.indexOf("Linux") > -1;
  },
  methods: {
    authorization,
    orderTypeFormat,
    repairTypeFormat,
	valueByKey,
    confirmExamine(type) {
      if (type === 4) {
        if (
          this.examineParams.rejectRemark === "" ||
          this.examineParams.rejectRemark === undefined
        ) {
          Toast.fail("请填写驳回理由");
          return;
        }
      }
      this.examineParams.type = type;
      this.axios({
        method: "post",
        url: "/v1/web/order-info/examine-order",
        data: this.examineParams,
      }).then((res) => {
        if (res.data.code === 200) {
          if (type == 4) {
            Toast.success("驳回成功");
          } else if (type == 6) {
            Toast.success("审核通过");
          }
          this.selectOrderDetail(false);
          this.showExamine = false;
        } else {
          Toast.fail(res.data.message);
        }
      });
    },
    toExamine(id) {
      this.examineParams.orderId = id;
      this.examineParams.orderIds = [];
      this.examineParams.orderIds.push(id);
      this.showExamine = true;
    },
    queryCategoryDrown() {
      this.axios({
        method: "get",
        url: "/v1/web/device-category/select-category",
      }).then((res) => {
        this.deviceCategoryCol = res.data.data.list;
      });
    },
    queryCableBrandDrown() {
      this.axios({
        method: "get",
        url: "/v1/web/cable-brand/select-cable-brand",
      }).then((res) => {
        this.cableBrandCol = res.data.data.list;
        this.cableBrandCol.push({ id: -1, brandName: "其他" });
      });
    },
    getFollowRemarkList(followRemark) {
      if (followRemark === undefined || followRemark === null) {
        return [];
      }
      return followRemark.split(";");
    },
    dateFormat(time) {
      if (time !== null && time !== undefined) {
        return moment(time).format("YYYY-MM-DD HH:mm:ss");
      }
    },
    getDeviceList() {
      this.axios({
        method: "get",
        url: "/v1/h5/device-manage/list-device-drown",
      }).then((res) => {
        this.deviceList = res.data.data;
      });
    },
    checkDate(time) {
      if (time === undefined || time === null) {
        return new Date();
      }
      return new Date(time);
    },
    /**
     * 删除物料
     * @param index
     */
    deleteMaterial(index) {
      this.orderDetail.materialOrderList.splice(index, 1);
    },
    onDeviceCategory({ selectedOptions }) {
      this.orderDetail.categoryId = selectedOptions[0].value;
      this.orderDetail.categoryName = selectedOptions[0].text;
      this.orderDetail.deviceNum = selectedOptions[1].text;
      this.showDeviceCategory = false;
    },
    onFinish({ selectedOptions }) {
      let obj = {};
      obj.typeId = selectedOptions[0].value;
      obj.typeName = selectedOptions[0].text;
      obj.modelId = selectedOptions[1].value;
      obj.modelName = selectedOptions[1].text;
      obj.num = 1;
      if (this.orderDetail.materialOrderList === undefined) {
        this.orderDetail.materialOrderList = [];
      }
      this.axios({
        method: "get",
        url: "/v1/h5/order-info/select-material-id",
        params: {
          id: obj.modelId,
        },
      }).then((res) => {
        let price = res.data.data.price;
        if (price === undefined || price === null) {
          price = 0;
        }
        obj.meterialPrice = price;
        obj.actualAmount = obj.meterialPrice * obj.num;
        this.orderDetail.materialOrderList.push(obj);
        this.showMaterial = false;
        this.materialModelValue = "";
      });
    },
    //获取物料类型
    selMaterialType() {
      this.axios({
        method: "get",
        url: "/v1/h5/order-info/select-material-type-drown",
      }).then((res) => {
        this.materialList = res.data.data;
      });
    },
    selDeviceCategory() {
      this.axios({
        method: "get",
        url: "/v1/web/device-category/select-device-category",
      }).then((res) => {
        this.deviceCategoryList = res.data.data;
      });
    },
    goback() {
      //返回上一页
      sessionStorage.removeItem("orderId");
      this.$router.push({ path: this.goBackUrl, query: { type: this.goBackType } });
    },
    onSource(value) {
      //电池来源确认
      this.orderDetail.powerSource = value;
      this.showSource = false;
    },
    onDisposeType(value) {
      this.orderDetail.oldDisposeType = value.value;
      this.oldDisposeTypeStr = value.label;
      this.showDisposeType = false;
    },
    onCableBrand(value) {
      //电缆品牌确认
      this.orderDetail.cableBrandId = value.id;
      this.orderDetail.cableBrandName = value.brandName;
      this.orderDetail.cableBrandNameTmp = value.brandName;
      if (this.orderDetail.cableBrandId === -1) {
        this.orderDetail.cableBrandName = "";
        this.showCableBrandOther = true;
      } else {
        this.showCableBrandOther = false;
      }

      this.showCableBrand = false;
    },
    onChoiceX(value) {
      this.orderDetail.isSelfPickup = value.value;
      this.isSelfPickup = value.label;
      this.showChoiceX = false;
    },

    onChoiceY(value) {
      this.orderDetail.isWiring = value.value;
      this.isWiring = value.label;
      this.showChoiceY = false;
    },
    onChoiceZ(pickerValue) {
      const selectedHouseItem = this.houseTypeList.find(
        (item) => item.houseTypeName === pickerValue.houseTypeName
      );
      this.houseType = pickerValue.houseTypeName;
      if (selectedHouseItem) {
        this.selectedHouseTypeId = selectedHouseItem.id; // 仅保存住宅类型的 id
        //console.log('选择的住宅类型 ID:', this.selectedHouseTypeId);
      }
      this.orderDetail.houseType = this.selectedHouseTypeId;
      this.showChoiceZ = false; // 选择后关闭弹窗
    },

    onChoice1(value) {
      //是否签免责确认
      this.orderDetail.signExemption = value.value;
      this.signExemptionStr = value.label;
      this.showChoice1 = false;
    },
    onChoice2(value) {
      //是否购买延长线确认
      this.orderDetail.purchaseExtension = value.value;
      this.purchaseExtensionStr = value.label;
      this.showChoice2 = false;
    },
    onSelfPickUp(value) {
      this.orderDetail.isSelfPickup = value.value;
      this.selfPickupStr = value.label;
      this.isSelfPickup = value.value;
      this.showSelfPickup = false;
      if (this.isSelfPickup == 1) {
        this.orderDetail.orderType = 3;
        this.setOrderType();
        this.selectImageSetting();
      }
      console.log(this.imageSetting);
    },
    setOrderType() {
      this.axios({
        method: "put",
        url: "/v1/web/order-info/update-order-type",
        params: {
          id: this.orderId,
          orderType: 3,
        },
      }).then((res) => {
        if (res.data.code == 200) {
          return;
        }
      });
    },
    onDeviceList(value) {
      this.orderDetail.deviceNum = value.label.substring(0, value.label.indexOf("("));
      this.deviceListIsShow = false;
    },
    onCategoryList(value) {
      this.orderDetail.categoryId = value.id;
      this.orderDetail.categoryName = value.categoryName;
      //切换充电桩类型的时候，刷新下模板
      if (this.categoryListIsShow) {
        this.selectImageSetting();
      }

      this.categoryListIsShow = false;
    },
    onTime(value) {
      //实际安装实际确认
      //this.installationTime=moment(value).format("YYYY-MM-DD HH:mm:ss");
      this.orderDetail.installTime = value.getTime();
      this.showTime = false;
    },
    changeTime(time) {
      if (time === null) {
        //return moment(new Date().getTime()).format("YYYY-MM-DD HH:mm:ss");
        return "";
      }
      return moment(time).format("YYYY-MM-DD HH:mm:ss");
    },
    printHouseTypeName(houseType) {
      if (houseType == 0) {
        return "农村自建房";
      }
      if (houseType == 1) {
        return "城市小区";
      }
      if (houseType == 2) {
        return "城市自建房";
      }
      if (houseType == 3) {
        return "工厂";
      }
      if (houseType == 4) {
        return "其他";
      }
    },
    selectOrderDetail(loadImageSetting) {
      this.axios({
        method: "get",
        url: "/v1/h5/order-info/select-order-detail",
        params: {
          id: this.orderId,
        },
      }).then(async (res) => {
        let resultData = res.data.data;
        this.orderDetail = resultData;
        this.isWiring = this.orderDetail.isWiring ? "是" : "否";
        this.houseType = this.printHouseTypeName(this.orderDetail.houseType);
        if (this.orderDetail.categoryId == null) {
          this.orderDetail.categoryId = this.orderDetail.storeId;
          this.orderDetail.categoryName = this.orderDetail.storeName;
        }

        this.getDeviceByCategory();

        if (this.deviceNum !== undefined) {
          this.orderDetail.deviceNum = this.deviceNum;
        }

        if (this.orderDetail.cableBrandId == -1) {
          this.orderDetail.cableBrandNameTmp = "其他";
          this.showCableBrandOther = true;
        } else {
          this.orderDetail.cableBrandNameTmp = this.orderDetail.cableBrandName;
          this.showCableBrandOther = false;
        }

        let type;
        switch (this.orderDetail.orderType) {
          case 2:
            type = "维修";
            break;
          case 3:
            type = "自提";
            break;
          default:
            type = "安装";
            break;
        }
        this.installTimeLable = "实际" + type + "时间";

        //获取原订单充电桩编号
        if (this.orderDetail.oldOrderNum != null && this.orderDetail.oldOrderNum != "") {
          this.selectDeviceNumByOrderNum(this.orderDetail.oldOrderNum);
        }

        //自提单的是否自提默认为是
        let isSelfObj;
        if (this.orderDetail.orderType === 3) {
          isSelfObj = this.commonBoolChoiceList[0];
        } else {
          isSelfObj = this.commonBoolChoiceList[1];
        }
        this.onSelfPickUp(isSelfObj);
        //原充电桩处理方式
        if (
          this.orderDetail.oldDisposeType != null &&
          this.orderDetail.oldDisposeType != undefined
        ) {
          this.onDisposeType(this.disposeTypeList[this.orderDetail.oldDisposeType - 1]);
        }

        //快递单据信息
        if (this.orderDetail.orderCourier != null) {
          this.orderCourier = this.orderDetail.orderCourier;
          this.handlePreviewImage(this.orderCourier.courierImageUrl, -4); //快递单据图
        }

        this.handlePreviewImage(resultData.reserve1, -1); //其他图片
        this.handlePreviewImage(resultData.reserve3, -2); //免责图
        this.handlePreviewImage(resultData.surveyImageUrl, -3); //勘测确认单
        this.handlePreviewImage(resultData.videoUrl, -99); //视频
        if (this.orderDetail.signExemption === 0) {
          this.signExemptionStr = "未签";
        } else if (this.orderDetail.signExemption === 1) {
          this.signExemptionStr = "已签";
        }
        if (this.orderDetail.purchaseExtension === 0) {
          this.purchaseExtensionStr = "未购买";
        } else if (this.orderDetail.purchaseExtension === 1) {
          this.purchaseExtensionStr = "已购买";
        }

        if (loadImageSetting) {
          await this.selectImageSetting();
        } else {
          await this.selectOrderImageSettingDetailList();
        }
      });
    },
    selectOrderImageSettingDetailList: async function () {
      this.axios({
        method: "get",
        url: "/v1/web/device-image-setting/select-order-image-detail",
        params: {
          orderId: this.orderId,
        },
      }).then((res) => {
        let resultData = res.data.data;
        if (resultData != null && resultData.length > 0) {
          // 使用 $set 确保 templateDetailList 是响应式的
          this.$set(this.imageSetting, 'templateDetailList', resultData);
          for (let i = 0; i < this.imageSetting.templateDetailList.length; i++) {
            let image = this.imageSetting.templateDetailList[i];
            // 使用 $set 确保响应式，先初始化 imageUploader
            if (!image.imageUploader) {
              this.$set(image, 'imageUploader', []);
            } else {
              // 如果已存在，使用 $set 清空数组，确保响应式
              this.$set(image, 'imageUploader', []);
            }
            // 支持多张图片，URL可能是逗号分隔的
            if (image.url && image.url.includes(",")) {
              let urls = image.url.split(",");
              for (let j = 0; j < urls.length; j++) {
                if (urls[j] && urls[j].trim()) {
                  this.handlePreviewImage(urls[j].trim(), image.id);
                }
              }
            } else {
            this.handlePreviewImage(image.url, image.id);
            }
            this.$forceUpdate();
          }
        }
        // 更新后重新计算数量标签位置
        this.$nextTick(() => {
          this.updateBadgePositions();
        });
      });
    },
    updateBadgePositions() {
      //更新所有数量标签的位置
      if (this.imageSetting && this.imageSetting.templateDetailList) {
        this.imageSetting.templateDetailList.forEach(img => {
          const uploaderId = img.id;
          const uploader = this.$refs['uploader_' + uploaderId];
          if (uploader && uploader.$el) {
            const firstPreview = uploader.$el.querySelector('.van-uploader__preview:first-child');
            if (firstPreview) {
              const rect = firstPreview.getBoundingClientRect();
              const containerRect = uploader.$el.getBoundingClientRect();
              this.$set(this.badgePositions, uploaderId, {
                position: 'absolute',
                top: (rect.top - containerRect.top + 4) + 'px',
                right: (containerRect.right - rect.right + 4) + 'px',
                backgroundColor: 'rgba(0, 0, 0, 0.6)',
                color: 'white',
                padding: '2px 6px',
                borderRadius: '4px',
                fontSize: '11px',
                fontWeight: 'bold',
                zIndex: 10,
                pointerEvents: 'none'
              });
            }
          }
        });
      }
    },
    selectImageSetting: async function () {
      let params = {
        orderType: this.orderDetail.orderType,
        repairType: this.orderDetail.orderType === 2 ? this.orderDetail.repairType : null,
        deviceCategoryId: this.orderDetail.categoryId,
        companyId: this.orderDetail.companyId,
      };

      this.axios({
        method: "get",
        url: "/v1/web/device-image-setting/select-image-setting",
        params: params,
      }).then((res) => {
        if (res.data.data.list.length > 0) {
          this.imageSetting = res.data.data.list[0];
          this.selectOrderImageSettingDetailList();
        } else {
          Toast.fail("该充电桩类型未配置图片模板，请联系管理员");
          return;
        }
      });
    },
    selectDeviceNumByOrderNum(orderNum) {
      this.axios({
        method: "get",
        url: "/v1/web/order-info/selectDeviceInfoByOrderNum",
        params: { orderNum: orderNum },
      }).then((res) => {
        let oldDevice = res.data && res.data.data;
        if (oldDevice != null) {
          this.oldDeviceNum = oldDevice.deviceNum;
          //非换桩维修时，相关信息默认值
          if (this.orderDetail.orderType === 2 && this.orderDetail.repairType !== 1) {
            this.orderDetail.deviceNum = this.oldDeviceNum;
            this.orderDetail.powerSource = oldDevice.powerSource;
            this.orderDetail.cableBrandId = oldDevice.cableBrandId;
            this.orderDetail.cableBrandNameTmp = oldDevice.cableBrandName;
            this.orderDetail.cableBrandName = oldDevice.cableBrandName;
          }
        }
      });
    },
    checkImageSettingData() {
      if (
        this.imageSetting.templateDetailList != null &&
        this.imageSetting.templateDetailList.length > 0
      ) {
        for (let i = 0; i < this.imageSetting.templateDetailList.length; i++) {
          let image = this.imageSetting.templateDetailList[i];
          if (image.isRequired === 1) {
            // 支持多张图片，url可能是逗号分隔的多个URL
            let imageUrls = image.url ? image.url.split(",").filter(url => url && url.trim()) : [];
            let miniUrls = image.miniUrl ? image.miniUrl.split(",").filter(url => url && url.trim()) : [];
            
            if (imageUrls.length === 0 || miniUrls.length === 0) {
              Toast.fail(image.imageName + "不能为空!");
              return false;
            }
            
            // 检查图片数量是否超过最大限制
            let maxCount = image.maxCount || 10;
            if (imageUrls.length > maxCount) {
              Toast.fail(image.imageName + "最多只能上传" + maxCount + "张!");
              return false;
            }
          }
        }
      }

      return true;
    },
    onSubmit(submitType) {
      var isCheckByIsSelfPickup = true;
      if (this.orderDetail.isSelfPickup === 1) {
        isCheckByIsSelfPickup = false;
        this.orderDetail.powerSource = null;
        this.orderDetail.cableBrandId = null;
        this.orderDetail.cableBrandName = null;
        this.orderDetail.cableBrandNameTmp = null;
        this.orderDetail.lineLength = null;
        this.orderDetail.addOutlay = null;
        this.orderDetail.signExemption = null;
        this.orderImage.reserve3Uploader = [];
        this.orderDetail.purchaseExtension = null;
        this.orderDetail.materialOrderList = [];
      }

      if (this.orderDetail.signExemption === 0) {
        this.orderDetail.reserve3 = null;
      }

      this.orderDetail.orderCourier = null;
      if (this.orderCourier != null) {
        this.orderDetail.orderCourier = this.orderCourier;
      }

      this.orderDetail.submitType = submitType;
      if (submitType === 1) {
        if (this.orderDetail.detailAddress == "") {
          Toast.fail("详细地址不能为空");
          return;
        }
        if (
          this.orderDetail.deviceNum == "" &&
          this.checkRequiredUnSelfPickup(this.orderDetail)
        ) {
          Toast.fail("充电桩编号不能为空");
          return;
        }
        if (
          this.orderDetail.categoryId == "" &&
          this.checkRequiredUnSelfPickup(this.orderDetail)
        ) {
          Toast.fail("充电桩类型不能为空");
          return;
        }
        if (isCheckByIsSelfPickup) {
          if (
            this.orderDetail.powerSource == "" &&
            this.checkRequiredUnSelfPickup(this.orderDetail)
          ) {
            Toast.fail("电源来源不能为空");
            return;
          }
          if (
            this.orderDetail.cableBrandName == "" &&
            this.checkRequiredUnSelfPickup(this.orderDetail)
          ) {
            Toast.fail("电缆品牌不能为空");
            return;
          }
          if (
            this.orderDetail.lineLength == "" &&
            this.checkRequiredUnSelfPickup(this.orderDetail)
          ) {
            Toast.fail("用线长度不能为空");
            return;
          }
          if (
            this.orderDetail.addOutlay == "" &&
            this.checkRequiredUnSelfPickup(this.orderDetail)
          ) {
            Toast.fail("增项费用不能为空");
            return;
          }
          if (
            this.orderDetail.signExemption == null &&
            this.checkRequiredUnSelfPickup(this.orderDetail)
          ) {
            Toast.fail("是否签免责不能为空");
            return;
          }
        //   if (
        //     this.orderDetail.purchaseExtension == null &&
        //     this.checkRequiredUnSelfPickup(this.orderDetail)
        //   ) {
        //     Toast.fail("是否购买延长线不能为空");
        //     return;
        //   }
		if (
            !this.orderDetail.frontEndCable  &&
            this.orderDetail.orderType === 1
          ) {
            Toast.fail("【新订单】类型，前端线材不能为空");
            return;
          }
        }

        if (
          this.orderImage.reserve3Uploader == "" &&
          this.orderDetail.signExemption === 1
        ) {
          Toast.fail("免责图不能为空");
          return;
        }

        if (this.orderDetail.installTime == null) {
          Toast.fail("实际安装时间不能为空");
          return;
        }
        if (this.orderImage.surveyImageUploader == "") {
          Toast.fail("勘测确认单不能为空");
          return;
        }

        if (this.orderDetail.addOutlay > 0 && this.orderDetail.materialOrderList <= 0) {
          Toast.fail("增项费用大于0时超出后物料不能为空");
          return;
        }

        if (!this.checkImageSettingData()) {
          return;
        }

        this.$refs.completeRules
          .validate()
          .then(() => {
            this.requestSubmit(submitType);
          })
          .catch((e) => {
            console.log(e);
            Toast.fail("校验错误");
          });
      } else {
        // if (this.orderDetail.deviceNum == '' && this.checkShowDeviceNum(this.orderDetail)) {
        // 	Toast.fail('充电桩编号不能为空');
        // 	return;
        // }
        this.requestSubmit(submitType);
      }
    },
    requestSubmit(submitType) {
      this.orderDetail.orderImageSettingDetailList = this.imageSetting.templateDetailList;
      if (submitType === 0) {
        this.required = false;
      } else {
        this.required = true;
      }
      this.axios({
        method: "post",
        url: "/v1/h5/order-info/complete-order/" + this.orderDetail.id,
        data: this.orderDetail,
      })
        .then((res) => {
          if (res.data.code === 200) {
            if (submitType === 0) {
              Toast.success("暂存成功");
            } else {
              Toast.success("提交成功");
            }
            this.$router.push({ path: "/OrderList", query: { type: "2" } });
          } else {
            Toast.fail(res.data.message);
          }
        })
        .catch(() => {
          Toast.fail("系统异常,请联系工作人员!");
        });
    },
    async afterRead(file, detail) {
      this.uploadImage(file.file, detail.name, false);
    },
    imageUploadOuther(file, detail) {
      if (file.length === undefined) {
        this.imageUpload(file, detail);
      } else {
        // 模板图片需要检查maxCount限制
        if (detail.name > 0) {
          let image = this.imageSetting.templateDetailList.find((x) => x.id === detail.name);
          if (image) {
            let maxCount = image.maxCount || 10;
            let currentCount = image.imageUploader ? image.imageUploader.length : 0;
            if (currentCount + file.length > maxCount) {
              Toast.fail(image.imageName + "最多只能上传" + maxCount + "张照片");
              return;
            }
          }
        } else if (detail.name === -1) {
        if (this.orderImage.reserve1Uploader.length + file.length >= 40) {
          Toast.fail("最多只能上传40张照片");
          return;
          }
        }
        for (let i = 0; i < file.length; i++) {
          this.imageUpload(file[i], detail);
        }
      }
    },
    imageUpload(file, detail) {
      if (detail.name === -1) {
        if (this.orderImage.reserve1Uploader.length >= 40) {
          Toast.fail("最多只能上传40张照片");
          return;
        }
      }

      this.clickUpload(detail.name, file);
    },
    /**
     * 压缩图片
     * @param file
     * @returns {Promise<unknown>}
     */
    compressFile(file, quality) {
      return new Promise((resolve, reject) => {
        new ImageCompressor(file, {
          quality: quality, //压缩质量
          checkOrientation: false, //图片翻转，默认为false
          success(result) {
            resolve(result);
          },
          error(e) {
            reject(e);
          },
        });
      });
    },
    deleteImage(file, detail) {
      console.log('=== 删除图片开始 ===');
      console.log('删除参数 detail:', JSON.stringify(detail, null, 2));
      console.log('detail.name:', detail.name);
      console.log('detail.index:', detail.index);
      
      switch (detail.name) {
        case -1:
          //其他图片
          console.log('删除其他图片，删除前长度:', this.orderImage.reserve1Uploader.length);
          this.orderImage.reserve1Uploader.splice(detail.index, 1);
          console.log('删除后长度:', this.orderImage.reserve1Uploader.length);
          this.orderDetail.reserve1 = this.getImageUrlArray(
            this.orderImage.reserve1Uploader
          );
          console.log('更新后的 reserve1:', this.orderDetail.reserve1);
          // 返回 false 阻止 Vant 的默认删除行为，因为我们已经手动删除了
          return false;
        case -2:
          //免责图
          console.log('删除免责图，删除前长度:', this.orderImage.reserve3Uploader.length);
          this.orderImage.reserve3Uploader.splice(detail.index, 1);
          console.log('删除后长度:', this.orderImage.reserve3Uploader.length);
          this.orderDetail.reserve3 = this.getImageUrlArray(
            this.orderImage.reserve3Uploader
          );
          console.log('更新后的 reserve3:', this.orderDetail.reserve3);
          // 返回 false 阻止 Vant 的默认删除行为，因为我们已经手动删除了
          return false;
        case -3:
          //勘测确认图
          console.log('删除勘测确认图，删除前长度:', this.orderImage.surveyImageUploader.length);
          this.orderImage.surveyImageUploader.splice(detail.index, 1);
          console.log('删除后长度:', this.orderImage.surveyImageUploader.length);
          this.orderDetail.surveyImageUrl = this.getImageUrlArray(
            this.orderImage.surveyImageUploader
          );
          console.log('更新后的 surveyImageUrl:', this.orderDetail.surveyImageUrl);
          // 返回 false 阻止 Vant 的默认删除行为，因为我们已经手动删除了
          return false;
        case -4:
          //快递单据图
          console.log('删除快递单据图');
          this.orderCourier.courierImageUploader = [];
          this.orderCourier.courierImageUrl = "";
          return true;
        case -99:
          console.log('删除视频');
          this.orderImage.videoUploader = [];
          this.orderDetail.videoUrl = "";
          return true;
        default:
          //模板图片
          console.log('删除模板图片，detail.name:', detail.name);
          console.log('imageSetting:', this.imageSetting);
          console.log('templateDetailList 长度:', this.imageSetting && this.imageSetting.templateDetailList ? this.imageSetting.templateDetailList.length : 0);
          
          if (
            this.imageSetting.templateDetailList != null &&
            this.imageSetting.templateDetailList.length > 0
          ) {
            let image = this.imageSetting.templateDetailList.find(
              (x) => x.id === detail.name
            );
            console.log('找到的 image 对象:', image);
            console.log('image.id:', image ? image.id : undefined);
            console.log('image.imageName:', image ? image.imageName : undefined);
            
            if (image) {
              console.log('删除前 image.imageUploader 长度:', image.imageUploader ? image.imageUploader.length : 0);
              console.log('删除前 image.imageUploader:', JSON.stringify(image.imageUploader, null, 2));
              console.log('删除前 image.url:', image.url);
              console.log('删除前 image.miniUrl:', image.miniUrl);
              console.log('要删除的索引 detail.index:', detail.index);
              
              // 删除指定索引的图片
              if (image.imageUploader && image.imageUploader.length > detail.index) {
                // 保存要删除的图片的URL路径，用于从url和miniUrl中匹配删除
                let deletedItem = image.imageUploader[detail.index];
                let deletedPath = null;
                if (deletedItem && deletedItem.url) {
                  // 从预览URL中提取实际路径: /api/v1/web/order-info/preview-image?path=/xxx -> /xxx
                  let match = deletedItem.url.match(/[?&]path=([^&]+)/);
                  if (match && match[1]) {
                    deletedPath = decodeURIComponent(match[1]);
                  }
                }
                console.log('要删除的图片路径:', deletedPath);
                
                // 删除 imageUploader 中的项
                image.imageUploader.splice(detail.index, 1);
                console.log('删除后 image.imageUploader 长度:', image.imageUploader.length);
                console.log('删除后 image.imageUploader:', JSON.stringify(image.imageUploader, null, 2));
                
                // 根据 imageUploader 重新构建 url 和 miniUrl，确保数据同步
                // 方法1：从 imageUploader 中提取路径重新构建 url
                let newUrls = [];
                for (let i = 0; i < image.imageUploader.length; i++) {
                  let item = image.imageUploader[i];
                  if (item && item.url) {
                    let match = item.url.match(/[?&]path=([^&]+)/);
                    if (match && match[1]) {
                      newUrls.push(decodeURIComponent(match[1]));
                    }
                  }
                }
                image.url = newUrls.length > 0 ? newUrls.join(",") : "";
                console.log('根据 imageUploader 重新构建的 image.url:', image.url);
                console.log('重新构建的 urls 数量:', newUrls.length);
                
                // 对于 miniUrl，由于 imageUploader 中没有 miniUrl 信息，需要从原 miniUrl 中删除对应项
                // 如果 deletedPath 存在，尝试从 miniUrl 中找到并删除对应的项
                if (deletedPath && image.miniUrl) {
                  let miniUrls = image.miniUrl.split(",").filter(url => url && url.trim());
                  // 尝试通过文件名匹配（因为 miniUrl 和 url 的文件名可能不同，但应该在同一目录）
                  // 或者简单地从对应索引删除
                  if (miniUrls.length > detail.index) {
                    miniUrls.splice(detail.index, 1);
                    image.miniUrl = miniUrls.length > 0 ? miniUrls.join(",") : "";
                    console.log('更新后的 image.miniUrl:', image.miniUrl);
                  } else if (miniUrls.length > 0) {
                    // 如果索引超出范围，尝试通过文件名匹配删除
                    let deletedFileName = deletedPath.split('/').pop();
                    let filteredMiniUrls = miniUrls.filter(url => {
                      let fileName = url.split('/').pop();
                      return fileName !== deletedFileName;
                    });
                    if (filteredMiniUrls.length < miniUrls.length) {
                      image.miniUrl = filteredMiniUrls.length > 0 ? filteredMiniUrls.join(",") : "";
                      console.log('通过文件名匹配删除后的 image.miniUrl:', image.miniUrl);
                    } else {
                      // 如果无法匹配，且 miniUrls 数量少于 imageUploader，保持原值
                      console.warn('无法匹配删除 miniUrl，保持原值。miniUrls长度:', miniUrls.length, 'imageUploader长度:', image.imageUploader.length);
                    }
                  }
                } else if (!image.miniUrl || image.miniUrl === '') {
                  image.miniUrl = "";
                }
                
                // 找到要更新的索引
                let imageIndex = this.imageSetting.templateDetailList.findIndex(x => x.id === detail.name);
                console.log('要更新的 image 在数组中的索引:', imageIndex);
                
                // 创建新的对象引用，确保 Vue 响应式更新
                if (imageIndex >= 0) {
                  // 创建新的 imageUploader 数组副本
                  let newImageUploader = image.imageUploader.map(item => ({ ...item }));
                  // 创建新的 image 对象
                  let newImage = {
                    ...image,
                    imageUploader: newImageUploader,
                    url: image.url,
                    miniUrl: image.miniUrl
                  };
                  
                  // 使用 $set 更新数组中的对象
                  this.$set(this.imageSetting.templateDetailList, imageIndex, newImage);
                  console.log('使用 $set 更新后的 image:', JSON.stringify(newImage, null, 2));
                  console.log('更新后 templateDetailList 长度:', this.imageSetting.templateDetailList.length);
                  
                  // 强制更新视图
                  this.$forceUpdate();
                } else {
                  console.error('未找到要更新的 image 索引');
                }
                
                // 更新后重新计算数量标签位置
                this.$nextTick(() => {
                  this.updateBadgePositions();
                });
                
                console.log('=== 删除图片完成 ===');
                return true; // 确认删除
              } else {
                console.warn('image.imageUploader 不存在或索引超出范围');
                console.log('image.imageUploader:', image.imageUploader);
                console.log('image.imageUploader?.length:', image.imageUploader ? image.imageUploader.length : 0);
                console.log('detail.index:', detail.index);
              }
            } else {
              console.error('未找到对应的 image 对象，detail.name:', detail.name);
            }
          } else {
            console.error('templateDetailList 为空或不存在');
          }
          console.log('=== 删除图片失败 ===');
          return false; // 如果找不到对应的图片，取消删除
      }
    },
    async clickUpload(type, file) {
      this.showLoading = true;
      let miniFile = file;
      if (type > 0) {
        let miniSize = 100 * 1024;
        if (file.size > miniSize) {
          miniFile = await this.compressFile(file, 0.1);
        }
      }
      let maxSize = 200 * 1024; //自己定义的文件大小，超过多少M就开始压缩(现在是200k)
      if (file.size > maxSize) {
        file = await this.compressFile(file, 0.2);
      }
      this.uploadImage(file, type, false);
      if (type > 0) {
        this.uploadImage(miniFile, type, true);
      }
    },
    uploadImage(file, type, isMini) {
      let param = new FormData(); //创建form对象
      param.append("files", file);
      param.append("orderNum", this.orderDetail.orderNum);
      this.axios({
        method: "post",
        url: "/v1/h5/order-info/image-upload",
        data: param,
      })
        .then((res) => {
          let imgUrl = res.data.data.imageUrl;
          if (!isMini) {
            this.handlePreviewImage(imgUrl, type);
            this.flagUpload = true;
          } else {
            this.setMiniImage(imgUrl, type);
          }
          this.showLoading = false;
        })
        .catch(() => {
          Toast.fail("上传失败");
          this.showLoading = false;
        });
    },

    scanCode() {
      this.$router.push({
        path: "/QCode",
        query: { codeType: "orderCode", isOpenScan: true },
      });
    },
    setMiniImage(miniImgUrl, type) {
      //压缩图片
      let miniImageObj = {};
      miniImageObj.url = this.transformUrl(miniImgUrl);
      if (type <= 0) {
        return;
      } else {
        //模板图片
        if (
          this.imageSetting.templateDetailList != null &&
          this.imageSetting.templateDetailList.length > 0
        ) {
          let image = this.imageSetting.templateDetailList.find((x) => x.id === type);
          // 支持多张图片，用逗号分隔
          if (image.miniUrl && image.miniUrl !== "") {
            image.miniUrl = image.miniUrl + "," + miniImgUrl;
          } else {
          image.miniUrl = miniImgUrl;
          }
        }
      }
    },
    handlePreviewImage(imgUrl, type) {
      if (
        imgUrl === undefined ||
        imgUrl === null ||
        imgUrl === "deleteImage" ||
        imgUrl == ""
      ) {
        return;
      }
      //默认图片
      let imageObj = {};
      imageObj.url = this.transformUrl(imgUrl);
      let imageArray;
      switch (type) {
        //其他图片
        case -1:
          imageArray = imgUrl.split(",");
          if (imageArray.length > 1) {
            for (let i = 0; i < imageArray.length; i++) {
              let image = {};
              image.url = this.transformUrl(imageArray[i]);
              this.orderImage.reserve1Uploader.push(image);
            }
          } else {
            this.orderImage.reserve1Uploader.push(imageObj);
          }
          this.orderDetail.reserve1 = this.getImageUrlArray(
            this.orderImage.reserve1Uploader
          );
          break;
        case -2:
          //免责图
          imageArray = imgUrl.split(",");
          if (imageArray.length > 1) {
            for (let i = 0; i < imageArray.length; i++) {
              let image = {};
              image.url = this.transformUrl(imageArray[i]);
              this.orderImage.reserve3Uploader.push(image);
            }
          } else {
            this.orderImage.reserve3Uploader.push(imageObj);
          }
          this.orderDetail.reserve3 = this.getImageUrlArray(
            this.orderImage.reserve3Uploader
          );
          break;
        //勘测确认图
        case -3:
          imageArray = imgUrl.split(",");
          if (imageArray.length > 1) {
            for (let i = 0; i < imageArray.length; i++) {
              let image = {};
              image.url = this.transformUrl(imageArray[i]);
              this.orderImage.surveyImageUploader.push(image);
            }
          } else {
            this.orderImage.surveyImageUploader.push(imageObj);
          }
          this.orderDetail.surveyImageUrl = this.getImageUrlArray(
            this.orderImage.surveyImageUploader
          );
          break;
        //快递单据图
        case -4:
          this.orderCourier.courierImageUploader = [];
          this.orderCourier.courierImageUploader.push(imageObj);
          this.orderCourier.courierImageUrl = imgUrl;
          break;
        //视频
        case -99:
          imageObj.type = "video";
          imageObj.isVideo = true;
          imageObj.file = new File([], "视频", {});
          this.orderImage.videoUploader = [];
          this.orderImage.videoUploader.push(imageObj);
          this.orderDetail.videoUrl = imgUrl;
          break;
        //模板图片
        default:
          if (
            this.imageSetting.templateDetailList != null &&
            this.imageSetting.templateDetailList.length > 0
          ) {
            let image = this.imageSetting.templateDetailList.find((x) => x.id === type);
            if (image) {
              // 使用 $set 确保响应式，解决 Vue2 无法检测新属性的问题
              if (!image.imageUploader) {
                this.$set(image, 'imageUploader', []);
              }
              // 检查是否已存在相同的图片，避免重复添加
              let exists = image.imageUploader.some(item => item.url === imageObj.url);
              if (!exists) {
                image.imageUploader.push(imageObj);
                // 支持多张图片，用逗号分隔
                if (image.url && image.url !== "") {
                  // 检查 url 中是否已包含该图片路径，避免重复
                  let urlArray = image.url.split(",").map(u => u.trim());
                  if (!urlArray.includes(imgUrl.trim())) {
                    image.url = image.url + "," + imgUrl;
                  }
                } else {
                  image.url = imgUrl;
                }
                // 强制更新视图，确保立即显示
                this.$forceUpdate();
              }
            }
          }
          break;
      }
    },
    transformUrl(url) {
      return "/api/v1/web/order-info/preview-image?path=" + url;
    },
    getImageCount(imageUrl) {
      //获取图片数量
      if (imageUrl === null || imageUrl === undefined || imageUrl === "") {
        return 0;
      }
      let urls = imageUrl.split(",").filter(url => url && url.trim());
      return urls.length;
    },
    getBadgeStyle(uploaderId) {
      //计算数量标签的位置，定位到第一张预览图片上
      if (this.badgePositions[uploaderId]) {
        return this.badgePositions[uploaderId];
      }
      
      // 默认样式（如果无法计算位置）
      const defaultStyle = {
        position: 'absolute',
        top: '4px',
        left: '4px',
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        color: 'white',
        padding: '2px 6px',
        borderRadius: '4px',
        fontSize: '11px',
        fontWeight: 'bold',
        zIndex: 10,
        pointerEvents: 'none'
      };
      
      // 异步计算位置
      this.$nextTick(() => {
        const uploader = this.$refs['uploader_' + uploaderId];
        if (uploader && uploader.$el) {
          const firstPreview = uploader.$el.querySelector('.van-uploader__preview:first-child');
          if (firstPreview) {
            const rect = firstPreview.getBoundingClientRect();
            const containerRect = uploader.$el.getBoundingClientRect();
            this.$set(this.badgePositions, uploaderId, {
              position: 'absolute',
              top: (rect.top - containerRect.top + 4) + 'px',
              right: (containerRect.right - rect.right + 4) + 'px',
              backgroundColor: 'rgba(0, 0, 0, 0.6)',
              color: 'white',
              padding: '2px 6px',
              borderRadius: '4px',
              fontSize: '11px',
              fontWeight: 'bold',
              zIndex: 10,
              pointerEvents: 'none'
            });
          }
        }
      });
      
      return defaultStyle;
    },
    previewImages(img, clickedIndex) {
      //预览图片列表，带底部缩略图
      if (!img.imageUploader || img.imageUploader.length === 0) {
        return;
      }
      let imageList = img.imageUploader.map(item => item.url);
      
      // 使用自定义预览弹窗，支持底部缩略图
      this.showImagePreview = true;
      this.previewImageList = imageList;
      this.currentPreviewIndex = clickedIndex !== undefined && clickedIndex !== null ? clickedIndex.index : 0;
      this.resetMobileImageZoom();
    },
    previewOtherImages(imageUploader, clickedIndex) {
      //预览其他图片列表（勘测确认单、其他多图等），带底部缩略图
      if (!imageUploader || imageUploader.length === 0) {
        return false;
      }
      let imageList = imageUploader.map(item => item.url);
      
      // 使用自定义预览弹窗，支持底部缩略图
      this.showImagePreview = true;
      this.previewImageList = imageList;
      // 使用点击的图片索引，如果没有传递则默认为 0
      this.currentPreviewIndex = clickedIndex !== undefined && clickedIndex !== null ? clickedIndex.index : 0;
      this.resetMobileImageZoom();
      // 返回 false 阻止默认预览行为
    },
    prevImageMobile() {
      //移动端上一张
      if (this.currentPreviewIndex > 0) {
        this.currentPreviewIndex--;
      } else {
        this.currentPreviewIndex = this.previewImageList.length - 1;
      }
      this.resetMobileImageZoom();
    },
    nextImageMobile() {
      //移动端下一张
      if (this.currentPreviewIndex < this.previewImageList.length - 1) {
        this.currentPreviewIndex++;
      } else {
        this.currentPreviewIndex = 0;
      }
      this.resetMobileImageZoom();
    },
    switchImageMobile(index) {
      //移动端切换图片
      this.currentPreviewIndex = index;
      this.resetMobileImageZoom();
    },
    resetMobileImageZoom() {
      //重置移动端图片缩放和位置
      this.mobileImageScale = 1;
      this.mobileImageTranslateX = 0;
      this.mobileImageTranslateY = 0;
      this.isMobileDragging = false;
    },
    onMobileImageLoad() {
      //移动端图片加载完成后重置缩放
      this.resetMobileImageZoom();
    },
    handleDoubleClickMobile() {
      //移动端双击缩放
      if (this.mobileImageScale > 1) {
        this.resetMobileImageZoom();
      } else {
        this.mobileImageScale = 2;
      }
    },
    handleTouchStart(e) {
      //移动端触摸开始
      if (e.touches.length === 1) {
        //单指拖拽
        if (this.mobileImageScale > 1) {
          this.isMobileDragging = true;
          const touch = e.touches[0];
          this.lastTouchCenter.x = touch.clientX - this.mobileImageTranslateX;
          this.lastTouchCenter.y = touch.clientY - this.mobileImageTranslateY;
        }
      } else if (e.touches.length === 2) {
        //双指缩放
        this.isMobileDragging = false;
        const touch1 = e.touches[0];
        const touch2 = e.touches[1];
        this.touchStartDistance = Math.sqrt(
          Math.pow(touch2.clientX - touch1.clientX, 2) + 
          Math.pow(touch2.clientY - touch1.clientY, 2)
        );
        this.touchStartScale = this.mobileImageScale;
        this.lastTouchCenter.x = (touch1.clientX + touch2.clientX) / 2;
        this.lastTouchCenter.y = (touch1.clientY + touch2.clientY) / 2;
      }
    },
    handleTouchMove(e) {
      //移动端触摸移动
      e.preventDefault();
      if (e.touches.length === 1 && this.isMobileDragging && this.mobileImageScale > 1) {
        //单指拖拽
        const touch = e.touches[0];
        this.mobileImageTranslateX = touch.clientX - this.lastTouchCenter.x;
        this.mobileImageTranslateY = touch.clientY - this.lastTouchCenter.y;
      } else if (e.touches.length === 2) {
        //双指缩放
        const touch1 = e.touches[0];
        const touch2 = e.touches[1];
        const currentDistance = Math.sqrt(
          Math.pow(touch2.clientX - touch1.clientX, 2) + 
          Math.pow(touch2.clientY - touch1.clientY, 2)
        );
        const scale = this.touchStartScale * (currentDistance / this.touchStartDistance);
        this.mobileImageScale = Math.max(0.5, Math.min(5, scale));
        if (this.mobileImageScale === 1) {
          this.mobileImageTranslateX = 0;
          this.mobileImageTranslateY = 0;
        }
      }
    },
    handleTouchEnd() {
      //移动端触摸结束
      this.isMobileDragging = false;
    },
    zoomInMobile() {
      //移动端放大
      this.mobileImageScale = Math.min(5, this.mobileImageScale + 0.5);
    },
    zoomOutMobile() {
      //移动端缩小
      this.mobileImageScale = Math.max(0.5, this.mobileImageScale - 0.5);
      if (this.mobileImageScale === 1) {
        this.mobileImageTranslateX = 0;
        this.mobileImageTranslateY = 0;
      }
    },
    getImageUrlArray(imageObjs) {
      let resultStr = "";
      for (let i = 0; i < imageObjs.length; i++) {
        if (resultStr !== "") {
          resultStr = resultStr + ",";
        }
        resultStr =
          resultStr + imageObjs[i].url.substring(imageObjs[i].url.indexOf("=") + 1);
      }
      return resultStr;
    },
    unbindDevice() {
      Dialog.confirm({
        title: "提示",
        message: "确认解绑当前充电桩并清空充电桩详情吗？",
      })
        .then(() => {
          this.axios({
            method: "post",
            url: `/v1/web/order-info/unbind-device-h5/${this.orderId}`,
          }).then((res) => {
            if (res.data.code === 200) {
              Toast.success("解绑成功");
              // 清空本地充电桩相关字段
              this.orderDetail.deviceNum = "";
              this.orderDetail.categoryName = "";
              this.orderDetail.powerSource = "";
              this.orderDetail.cableBrandNameTmp = "";
              this.orderDetail.cableBrandName = "";
              this.orderDetail.lineLength = "";
              this.orderDetail.addOutlay = "";
              this.orderDetail.isSelfPickup = null;
              this.orderDetail.houseType = null;
              this.orderDetail.isWiring = null;
              // 重新拉取当前分类库存
              this.getDeviceByCategory();
            } else {
              Toast.fail(res.data.message || "解绑失败");
            }
          });
        })
        .catch(() => {});
    },
    onDeviceNumClick() {
      if (!this.canEdit) {
        return;
      }
      if (this.orderDetail.orderType === 2 && this.orderDetail.repairType !== 1) {
        Toast.fail("维修类型为更换充电桩时才可修改充电桩编号");
        return;
      }
      this.showChangeDevice = true;
    },
    onRepairTypeConfirm(row) {
      const oldRepairType = this.orderDetail.repairType;
      const newRepairType = row.value;
      if (oldRepairType !== 1 && newRepairType === 1) {
        this.deviceNumBeforeReplace = this.orderDetail.deviceNum;
      }
      if (oldRepairType === 1 && newRepairType !== 1) {
        this.orderDetail.deviceNum = this.deviceNumBeforeReplace || this.oldDeviceNum;
      }
      this.orderDetail.repairType = newRepairType;
      this.showRepairType = false;
    },
    classChangeDevice(value) {
      if (value == null || value == undefined) {
        Toast.fail("您的库存中没有任何该类型的充电桩，请联系管理员。");
        this.showChangeDevice = false;
        return;
      }

      this.orderDetail.deviceNum = value.deviceNum;
      this.showChangeDevice = false;
    },
    onInput() {
      let newArray = [];
      for (let i = 0; i < this.changeDeviceList.length; i++) {
        if (this.changeDeviceList[i].deviceNum.indexOf(this.searchDevice) >= 0) {
          newArray.push(this.changeDeviceList[i]);
        }
      }
      if (this.searchDevice === "" || this.searchDevice === undefined) {
        this.changeDeviceList = this.oldChangeDeviceList;
      } else {
        this.changeDeviceList = [];
        this.changeDeviceList = newArray;
      }
    },
    getDeviceByCategory() {
      let params = {
        numNotNull: "true",
        status: 0,
        isContainsGroup: true,
        haveUser: localStorage.getItem("userId"),
        categoryId: this.orderDetail.storeId,
        companyId: this.orderDetail.companyId,
      };
      this.axios({
        method: "get",
        url: "/v1/web/device-manage/list-device-manage",
        params: params,
      }).then((res) => {
        this.changeDeviceList = res.data.data.list;
        this.oldChangeDeviceList = res.data.data.list;
      });
    },
    calcMaterialTotal(row) {
      row.allPrice = row.meterialPrice * row.num;
      row.actualAmount = row.allPrice;
    },
    checkShowUnSelfPickup(row) {
      return (
        row.deviceNum !== "" &&
        row.isSelfPickup !== 1 &&
        (row.orderType !== 2 || (row.orderType === 2 && row.repairType === 1))
      );
    },
    checkRequiredUnSelfPickup(row) {
      return (
        row.isSelfPickup !== 1 &&
        (row.orderType !== 2 || (row.orderType === 2 && row.repairType === 1))
      );
    },
    checkShowDeviceNum(row) {
      return !(
        row.orderType === 2 &&
        row.repairType !== 1 &&
        (this.oldDeviceNum == null || this.oldDeviceNum == "")
      );
    },
	// checkFontEndCable( row){
	// 	if( row.orderType===1){
	// 		return row.cableBrandNameTmp;
	// 	}
	// 	return row.cableBrandName;
	// },
    selectFollowDetail() {
      //获取跟进列表
      this.axios({
        method: "get",
        //后端接口
        url: "/v1/web/order-info/get-order-all-follow/" + this.orderId,
      }).then((res) => {
        this.followList = res.data.data;
      });
    },
    formattedFollowInfo(item) {
      if (
        item.followTime == null ||
        item.followTime == undefined ||
        item.followTime == ""
      ) {
        return "";
      }
      item.followTime = moment(item.followTime).format("YYYY-MM-DD");
      return `${item.followTime} (${item.followerName}): ${item.followInfo}`;
    },
  },
};
</script>

<style>
.van-field__label {
  color: rgb(120, 120, 120) !important;
}

.van-field__control {
  color: rgb(180, 180, 180) !important;
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: 120px;
  height: 120px;
  background-color: #fff;
}
.row-text {
  font-size: small;
  color: rgb(120, 120, 120) !important;
}

/* 图片数量标签定位到第一张预览图片上 */
.has-multiple-images ::v-deep .van-uploader__preview:first-child {
  position: relative;
}

.image-count-badge {
  position: absolute;
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: bold;
  z-index: 10;
  pointer-events: none;
}
</style>
